module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/sec_strengths_img02-41e9ad8591cbc421d2d7ea427ae77220.jpg";